{
  "toast": {
    "masterAdministratorCreated": "Master administrator created",
    "customPlanCreatedOrganizationCanSubscribeOnSubscription": "Custom plan created — organization can subscribe on Subscription page",
    "timezoneAdded": "Timezone added",
    "currencyAdded": "Currency added",
    "taxModeAdded": "Tax mode added",
    "added": "Added",
    "testEmailSentCheckTheInboxAndSpam": "Test email sent — check the inbox (and spam folder)",
    "passwordChanged": "Password changed",
    "organizationUpdated": "Organization updated",
    "organizationCreated": "Organization created",
    "organizationActivated": "Organization activated",
    "organizationDeactivated": "Organization deactivated",
    "platformSettingsSaved": "Platform settings saved — SSO, mail, and rate limits apply immediately"
  },
  "errors": {
    "failedToLoadAnalytics": "Failed to load analytics",
    "failedToCreateMasterAdministrator": "Failed to create master administrator",
    "failedToLoadRequests": "Failed to load requests",
    "failedToCreatePlan": "Failed to create plan",
    "zoneIdAndLabelAreRequired": "Zone ID and label are required",
    "currencyCodeAndNameAreRequired": "Currency code and name are required",
    "decimalPlacesMustBeBetween0And4": "Decimal places must be between 0 and 4",
    "taxModeCodeAndNameAreRequired": "Tax mode code and name are required",
    "codeAndNameAreRequired": "Code and name are required",
    "failedToLoadReferenceData": "Failed to load reference data",
    "couldNotAddTimezone": "Could not add timezone",
    "couldNotAddCurrency": "Could not add currency",
    "couldNotAddTaxMode": "Could not add tax mode",
    "couldNotAddEntry": "Could not add entry",
    "enterARecipientEmailForTheTest": "Enter a recipient email for the test",
    "testEmailFailedSaveSmtpSettingsFirstThen": "Test email failed — save SMTP settings first, then retry",
    "failedToLoadPlatformSettings": "Failed to load platform settings",
    "failedToSaveSettings": "Failed to save settings",
    "failedToChangePassword": "Failed to change password",
    "orgCodeMustBe13UppercaseLetters": "Org code must be 1–3 uppercase letters or digits",
    "saveFailed": "Save failed",
    "failedToLoadPlans": "Failed to load plans",
    "failedToLoadMasterAdministrators": "Failed to load master administrators",
    "failedToLoadUsers": "Failed to load users",
    "failedToLoadOrganizations": "Failed to load organizations",
    "failedToLoad": "Failed to load",
    "activateFailed": "Activate failed",
    "deactivateFailed": "Deactivate failed",
    "passwordsMustMatch": "Passwords must match"
  },
  "pages": {
    "platformAnalytics": "Platform Analytics",
    "platformInvoicesToday": "Platform Invoices Today",
    "salesToday": "Sales Today",
    "salesThisMonth": "Sales This Month",
    "masterAdministrators": "Master administrators",
    "newMasterAdministrator": "New master administrator",
    "platformOperatorsWhoCanAccessThe": "Platform operators who can access the master console",
    "customPlanRequests": "Custom plan requests",
    "reviewOrganizationRequestsAndPublishA": "Review organization requests and publish a private plan they can subscribe to.",
    "masterDashboard": "Master Dashboard",
    "totalOrganizations": "Total Organizations",
    "activeOrganizations": "Active Organizations",
    "activeSubscriptions": "Active Subscriptions",
    "todaySPlatformSales": "Today's Platform Sales",
    "todaySInvoices": "Today's Invoices",
    "monthSales": "Month Sales",
    "organizationMetrics": "Organization metrics",
    "platformWideOverview": "Platform-wide overview",
    "activeTenantsAndSubscriptions": "Active tenants and subscriptions",
    "referenceData": "Reference data",
    "globalCountriesCurrenciesTimezonesAndTax": "Global countries, currencies, timezones, and tax modes for tenant onboarding",
    "settings": "Settings",
    "security": "Security",
    "changePassword": "Change password",
    "general": "General",
    "ssoGoogleMicrosoft": "SSO (Google & Microsoft)",
    "emailSmtp": "Email (SMTP)",
    "rateLimiting": "Rate limiting",
    "platformConfigurationAccountSecurityAndMaster": "Platform configuration, account security, and master admin preferences.",
    "addAnExtraLayerOfProtection": "Add an extra layer of protection to your master account.",
    "useAStrongPasswordWithAt": "Use a strong password with at least 8 characters.",
    "frontendUrlCorsAndMfaIssuer": "Frontend URL, CORS, and MFA issuer.",
    "configureOauthProvidersForSingleSign": "Configure OAuth providers for single sign-on.",
    "outgoingMailForNotificationsAndPassword": "Outgoing mail for notifications and password resets.",
    "protectTheApiFromExcessiveRequest": "Protect the API from excessive request volume.",
    "platformUsers": "Platform users",
    "trackSignInAccountsAcrossAll": "Track sign-in accounts across all organizations and master operators",
    "organizations": "Organizations",
    "subscriptionPlans": "Subscription Plans",
    "subscriptions": "Subscriptions",
    "organizationSubscriptionStatusAcrossThePlatform": "Organization subscription status across the platform"
  },
  "labels": {
    "firstName": "First name *",
    "lastName": "Last name *",
    "email": "Email *",
    "password": "Password *",
    "planName": "Plan name",
    "monthlyPriceInr": "Monthly price (INR)",
    "yearlyPriceInr": "Yearly price (INR)",
    "maxStores": "Max stores",
    "maxEmployees": "Max employees",
    "maxProducts": "Max products",
    "description": "Description",
    "internalNotes": "Internal notes",
    "zoneIdIana": "Zone ID (IANA) *",
    "label": "Label *",
    "displayName": "Display name",
    "country": "Country",
    "region": "Region",
    "currencyCodeIso4217": "Currency code (ISO 4217) *",
    "name": "Name *",
    "symbol": "Symbol",
    "primaryCountry": "Primary country",
    "decimalPlaces": "Decimal places *",
    "isoNumericCode": "ISO numeric code",
    "taxModeCode": "Tax mode code *",
    "supportedTaxTypes": "Supported tax types",
    "code": "Code",
    "name2": "Name",
    "currentPassword": "Current password",
    "newPassword": "New password",
    "confirmPassword": "Confirm password",
    "loadingPlatformSettings": "Loading platform settings",
    "frontendUrl": "Frontend URL",
    "corsAllowedOriginsCommaSeparated": "CORS allowed origins (comma-separated)",
    "mfaIssuerName": "MFA issuer name",
    "oauthCallbackBaseUrl": "OAuth callback base URL",
    "clientId": "Client ID",
    "clientSecret": "Client secret",
    "fromEmail": "From email",
    "fromName": "From name",
    "smtpHost": "SMTP host",
    "port": "Port",
    "smtpUsername": "SMTP username",
    "smtpPassword": "SMTP password",
    "sendTestEmailTo": "Send test email to",
    "maxRequestsMinute": "Max requests / minute",
    "authEndpointsMaxMinute": "Auth endpoints max / minute",
    "accountType": "Account type",
    "orgCode": "Org code",
    "phone": "Phone",
    "gst": "GST",
    "city": "City",
    "eGFat": "e.g. FAT"
  },
  "validation": {
    "validEmail": "Enter a valid email",
    "passwordMin": "At least 8 characters",
    "firstNameRequired": "First name is required",
    "lastNameRequired": "Last name is required"
  },
  "masterAdmins": {
    "actions": {
      "addMasterAdmin": "Add master admin"
    },
    "columns": {
      "name": "Name",
      "email": "Email",
      "mfa": "MFA",
      "lastSignIn": "Last sign-in",
      "status": "Status"
    },
    "values": {
      "active": "Active",
      "inactive": "Inactive",
      "never": "Never",
      "off": "Off",
      "on": "On"
    }
  },
  "subscriptions": {
    "columns": {
      "organization": "Organization",
      "plan": "Plan",
      "status": "Status",
      "contact": "Contact"
    }
  },
  "users": {
    "actions": {
      "manageMasterAdmins": "Manage master admins"
    },
    "columns": {
      "name": "Name",
      "email": "Email",
      "organization": "Organization",
      "role": "Role",
      "type": "Type",
      "verified": "Verified",
      "status": "Status",
      "lastLogin": "Last login",
      "created": "Created"
    },
    "empty": {
      "noUsersFound": "No users found"
    },
    "filters": {
      "allUsers": "All users",
      "masterAdminsOnly": "Master admins only",
      "tenantUsersOnly": "Tenant users only"
    },
    "values": {
      "active": "Active",
      "inactive": "Inactive",
      "master": "Master",
      "masterAdmin": "Master Admin",
      "no": "No",
      "platform": "— Platform —",
      "tenant": "Tenant",
      "yes": "Yes"
    }
  },
  "plans": {
    "columns": {
      "code": "Code",
      "name": "Name",
      "description": "Description",
      "monthly": "Monthly",
      "yearly": "Yearly",
      "maxStores": "Max Stores",
      "maxEmployees": "Max Employees",
      "maxProducts": "Max Products"
    }
  },
  "settings": {
    "actions": {
      "reload": "Reload",
      "savePlatformSettings": "Save platform settings",
      "sendTestEmail": "Send test email",
      "updatePassword": "Update password"
    },
    "breadcrumbs": {
      "master": "Master",
      "settings": "Settings"
    },
    "help": {
      "mailLocalIn": "in",
      "mailLocalPrefix": "Local: set",
      "mailProduction": "Production: set host env on the server or save here (DB overrides env).",
      "platformOverridePrefix": "Values saved here override",
      "platformOverrideSuffix": "/ environment for SSO, mail, CORS, and rate limits. Secrets are never shown after save."
    },
    "labels": {
      "enabled": "Enabled",
      "enableSso": "Enable SSO"
    },
    "nav": {
      "platformConfig": "Platform config",
      "platformConfigDescription": "SSO, mail, CORS, and rate limits",
      "twoFactorAuth": "Two-factor auth",
      "twoFactorAuthDescription": "Protect your master account",
      "yourPassword": "Your password",
      "yourPasswordDescription": "Update your sign-in password"
    },
    "placeholders": {
      "enterSecret": "Enter secret",
      "keepExistingSecret": "••••••••  (leave blank to keep)",
      "oauthCallbackBaseUrl": "https://api.yourdomain.com/api",
      "testEmail": "you@example.com"
    },
    "providers": {
      "google": "Google",
      "microsoft": "Microsoft"
    },
    "status": {
      "emailNotFullyConfigured": "Email is not fully configured — set From email, SMTP host, username, and password, then save.",
      "outboundEmailConfigured": "Outbound email is configured (SMTP + from address)"
    }
  },
  "organizations": {
    "actions": {
      "addOrganization": "Add Organization"
    },
    "columns": {
      "created": "Created",
      "email": "Email",
      "name": "Name",
      "orgCode": "Org code",
      "phone": "Phone",
      "plan": "Plan",
      "status": "Status"
    },
    "hints": {
      "orgCode": "1–3 letters or digits. Leave blank to auto-generate from name."
    },
    "modal": {
      "editOrganization": "Edit Organization",
      "newOrganization": "New Organization"
    }
  },
  "customPlans": {
    "actions": {
      "createPlan": "Create plan"
    },
    "columns": {
      "contactEmail": "Contact email",
      "message": "Message",
      "organization": "Organization",
      "requested": "Requested",
      "status": "Status",
      "submitted": "Submitted"
    },
    "defaults": {
      "description": "Custom plan for organization",
      "organizationId": "Org #{{id}}",
      "planName": "Custom — {{organization}}"
    },
    "modal": {
      "planFor": "Plan for {{name}}"
    },
    "requestedLimits": "{{stores}} stores · {{staff}} staff · {{products}} products",
    "status": {
      "planReady": "Plan ready"
    }
  },
  "formActions": {
    "publishPlan": "Publish plan"
  },
  "framework": {
    "loadFailed": "Failed to load {{name}}",
    "savedSuccessfully": "Saved successfully",
    "saveFailed": "Save failed",
    "restoreRecord": "Restore record",
    "deactivateRecord": "Deactivate record",
    "restoreConfirm": "Restore {{name}}?",
    "deactivateConfirm": "Deactivate {{name}}?",
    "restore": "Restore",
    "deactivate": "Deactivate",
    "recordRestored": "Record restored",
    "recordDeactivated": "Record deactivated",
    "restoreFailed": "Restore failed",
    "deactivateFailed": "Deactivate failed",
    "deleteRecord": "Delete record",
    "deleteConfirm": "Delete {{name}}?",
    "delete": "Delete",
    "recordDeleted": "Record deleted",
    "deleteFailed": "Delete failed",
    "status": "Status",
    "importSubmitted": "Import submitted",
    "exportStarted": "Export started",
    "newEntity": "New {{name}}",
    "editEntity": "Edit {{name}}"
  },
  "localization": {
    "translations": {
      "title": "Translation Management",
      "description": "Manage translation keys, language values, diagnostics, import/export, and version history.",
      "language": "Language",
      "module": "Module",
      "allModules": "All modules",
      "search": "Search",
      "searchPlaceholder": "Search keys or values",
      "refresh": "Refresh",
      "export": "Export",
      "import": "Import",
      "importJson": "Import JSON",
      "importPlaceholder": "Paste an array of translation entries",
      "editTitle": "Edit translation",
      "key": "Key",
      "value": "Value",
      "actions": "Actions",
      "edit": "Edit",
      "save": "Save",
      "cancel": "Cancel",
      "empty": "No translations found",
      "noDiagnostics": "No translation diagnostics found",
      "status": "Status",
      "fallback": "Fallback",
      "loadHistory": "Load history",
      "noHistory": "No version history found",
      "oldValue": "Old value",
      "newValue": "New value",
      "loadFailed": "Failed to load translations",
      "saveFailed": "Failed to save translation",
      "saved": "Translation saved and applied",
      "exportFailed": "Failed to export translations",
      "exported": "Translations copied to clipboard",
      "importFailed": "Failed to import translations",
      "imported": "Translations imported and applied",
      "tabs": {
        "translations": "Translations",
        "missing": "Missing keys",
        "unused": "Unused keys",
        "history": "Version history",
        "import": "Import"
      }
    }
  }
}
